<th-app-notification></th-app-notification>

@if (selfServiceUnlockEnabled && isUnlockMode) {
  <th-account-unlock [initialUsername]="lockedOutUsername" (backToLogin)="backToLogin()"></th-account-unlock>
}

<div [hidden]="isUnlockMode">
  @if (loading) {
    <div class="d-flex justify-content-center">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    </div>
  }

  <div id="sign-in-widget" [hidden]="loading || widgetError"></div>
  @if (widgetError) {
    <div class="alert alert-danger mt-3">
      Unable to load the sign-in form. Please refresh the page or call support at {{ supportPhone }}.
    </div>
  }
</div>
